import angular from "angular";

angular
    .module('app')
    .component('userCreateForm', {
        template: require('./user-create-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.phone = null;
    $ctrl.name = null;
    $ctrl.last_name = null;
    $ctrl.type = null;
    $ctrl.password = null;
    $ctrl.validationErrors = [];
    $ctrl.sendInvite = false;

    $ctrl.phoneMasks = [
        {country: 'Kazakhstan', country_code: 'KZ', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Kyrgyzstan', country_code: 'KG', phone_code: '+996', phone_mask: '+\\9\\96 (999) 999-999'},
        {country: 'Russian', country_code: 'RU', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Usa', country_code: 'USA', phone_code: '+1', phone_mask: '+1 (999) 999-99-99'},
        {country: 'UAE', country_code: 'UAE', phone_code: '+971', phone_mask: '+\\971 (999) 99-9999'},
        {country: 'SPAIN', country_code: 'SPA', phone_code: '+34', phone_mask: '+34 (999) 999-999'}
    ];

    $ctrl.selectedMask = $ctrl.phoneMasks[0];

    $ctrl.$onInit = function () {
    };

    $ctrl.maskChanged = function () {
        $ctrl.phone = null;
    };

    $ctrl.save = function () {

        let req = null;
        $ctrl.loading = true;

        let params = {
            name: $ctrl.name,
            last_name: $ctrl.last_name,
            patronymic: $ctrl.patronymic,
            phone: $ctrl.phone.replace(/\D/g, ''),
            password: $ctrl.password,
            send_invite: $ctrl.sendInvite,
        };

        $http
            .post('/admin/users', {
                name: $ctrl.name,
                last_name: $ctrl.last_name,
                patronymic: $ctrl.patronymic,
                phone: $ctrl.phone.replace(/\D/g, ''),
                password: $ctrl.password,
                send_invite: $ctrl.sendInvite,
            })
            .then(
                function (response) {
                    if (!$ctrl.id) {
                        $ctrl.id = response.data.id;
                        Notifier.success('Успешно создан', 2);
                    }
                    $ctrl.close({
                        $value: {
                            id: $ctrl.id,
                            phone: $ctrl.phone.replace(/\D/g, ''),
                            full_name: $ctrl.name + ' ' + $ctrl.last_name,
                            name: $ctrl.name,
                            last_name: $ctrl.last_name,
                            patronymic: $ctrl.patronymic,
                            courses_count: 0,
                            logins_count: 0,
                            is_active: true,
                            created_at: new Date()
                        }
                    });

                },
                function (error) {
                    $ctrl.loading = false;

                    if (error.status === 422) {
                        $ctrl.validationErrors = error.data.errors;
                        Notifier.error('Ошибка при заполнении', 2);
                    } else {
                        Notifier.error('Произошла ошибка с текстом:' + error.data.message, 2);
                    }
                }
            );
    };

}
